<template>
  <div :class="['min-bag-container',showMyShopCart?'show-cart':'']">
    <template v-if="cartList.length==0||hasLogin">
      <div class="no-data">
        <div class="title">购物袋中没有商品</div>
        <div class="btn go-cart" @click="goToShopCart">
          <div>查看购物袋</div>
          <img class="icon" src="../../assets/image/icon/shop-cart-left.svg" />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="cart-list">
        <div
          class="cart-item"
          v-for="(item, index) in cartList"
          @click="goGoodDetail(item.pageUrl,item,index)"
          :key="index"
        >
          <div class="cart-img">
            <img :src="replaceImg(item.url)" />
          </div>

          <div class="cart-info">
            <div class="cart-info-detail">
              <div class="good-name">
                <span>{{item.name}}</span>
                <span class="last-pro" v-if="(item.status==0||item.status==3)&&item.stock==1">最后一件</span>
                <span class="last-pro" v-if="item.status==1">已下架</span>
                <span class="last-pro" v-if="item.status==2">售罄</span>
                <!-- <span class="last-pro">最后一件</span> -->
              </div>
              <div class="good-size">
                尺码：
                <span>{{item.specType[0]}}</span>
              </div>
              <div class="good-color">
                颜色：
                <span>{{item.colorText}}</span>
              </div>
              <!-- <div class="good-color">
              颜色：
              <span>灰色</span>
              </div>-->
              <!-- 7895658dedf64567aa5453796818333c
              bcb68ce1b290414f880e04ca552737fc
              804bc709c4184b9fa57517a10a5b5b5c
              b13ec01d1e2a496fb0342eeb9790df16-->
              <div class="good-num">
                数量：
                <span>{{item.count}}</span>
              </div>
              <div
                class="remove herf_tilte"
                @click.stop="removeCartitem(item.cartItemId,index,item)"
              >移除</div>
            </div>
            <div class="cart-price">
              <template v-if="item.discountPrice!='0'&&item.discountPrice!=undefined">
                <div class="originprice">¥{{$utils.toThousands(item.joinPrice) }}</div>
                <div class="currprice">¥{{$utils.toThousands(item.realTimePrice)}}</div>
              </template>
              <template v-else>
                <div class="currprice">¥{{$utils.toThousands(item.realTimePrice)}}</div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="summary">
        <div class="all-price">
          <div>小计</div>
          <div>¥{{$utils.toThousands(payAmount)}}</div>
        </div>
        <div class="btn" @click="goPay">
          <div>结算</div>
          <img class="icon" src="../../assets/image/icon/shop-cart-right.svg" />
        </div>
        <div class="btn go-cart" @click="goToShopCart">
          <div>查看购物袋</div>
          <img class="icon" src="../../assets/image/icon/shop-cart-left.svg" />
        </div>
      </div>
    </template>
    <leave-tip-pop
      @confirmPop="confirmPop"
      @cancelPop="cancelPop"
      :leavePopShow="leavePopShow"
      msg_1="提示……"
      msg_2="购物车中有售罄或下架商品，是否继续结算剩余商品？"
      btn_msg_1="继续结算"
      btn_msg_2="回到购物车"
    ></leave-tip-pop>
  </div>
</template>

<script>
import LeaveTipPop from "@/components/common/LeaveTipPop";

export default {
  name: "MinShopBag",
  data() {
    return {
      showAdd: false,
      visitStatus: false,
      hasLogin: window.localStorage.getItem("token"),
      ISNEXT: false,
      payAmount: 0,
      cartList: [],
      leavePopShow: false,
      backFlag: false,
      isSoldOut: false, //购物车是否有下架商品
      isSellOut: false, //是否有售罄商品
      API: this.$store.state.API
    };
  },
  props: {
    showMyShopCart: {
      type: Boolean,
      default: ""
    }
  },
  computed: {
    shopCartFalg() {
      return this.$store.state.shopCartFalg;
    },
    RefreshShopCart() {
      return this.$store.state.RefreshShopCart;
    },
    isExitlogin() {
      return this.$store.state.isExitlogin;
    }
  },
  watch: {
    showMyShopCart() {
      if (this.showMyShopCart) {
        this.gaViewItem(this.cartList);
      }
    },
    isExitlogin(curVal, oldVal) {
      //监听是否退出
      //  然后查下登录状态
      this.getLoginStatus().then(res => {
        this.hasLogin = res;
        if (!res) {
          this.getTotalPrice();
        }
      });
    },
    shopCartFalg(curVal, oldVal) {
      this.$emit("makeShopShow", true);

      //这里的curVal就是需要监听的值
    },
    RefreshShopCart(curVal, oldVal) {
      //这里的curVal就是需要监听的值
      this.getTotalPrice();
    }
  },
  components: {
    LeaveTipPop
  },
  mounted() {
    this.getLoginStatus().then(res => {
      if (res) {
        return;
      }

      this.getTotalPrice();
    });
  },
  methods: {
    replaceImg(img){
      if(img != null ){
        img = this.$utils.replaceImage(img);
        if(this.$utils.check_support_webp()){
          img = img +"?x-oss-process=tb_cart_prd_256"
        }
      }
      return img
    },
    goGoodDetail(url, good, index) {
      this.$router.push({
        name: "shopping",
        params: {
          friendly_url: url
        }
      });
      this.gaSelectContent(good, index);
    },

    getLoginStatus() {
      const that = this;
      return new Promise((resolve, reject) => {
        this.hasLogin = window.localStorage.getItem("token") ? false : true;
        resolve(this.hasLogin);
      });
    },
    goRouter(_r) {
      this.$router.push({ path: _r });
    },
    showLoginPop() {
      this.showLoginPop = !this.showLoginPop;
    },
    checkGoodStatus() {
      // 监测是否有售罄的
      this.isSoldOut = false;
      this.isSellOut = false;
      this.cartList.forEach((v, i) => {
        if (v.status == 1) {
          this.isSoldOut = true;
        }
        if (v.status == 2) {
          this.isSellOut = true;
        }
      });
    },
    getCartList() {
      // 获得购物车列表
     

      return new Promise(async (resolve, reject) => {
        let url = this.API.shopcart.cartList;
        let OpenId=await this.$utils.CheckOpenIdExist(this);
        let params = {
          openId: OpenId || this.$store.state.userId,
          merchantId: this.$store.state.storeId
        };
        this.$http
          .post(url, this.$qs.stringify(params))
          .then(res => {
            // 需要把有效的和无效的连在一块
            if (res.data.result) {
              let list = [];
              let skus = res.data.returnData.skus || [];
              let invalidSkus = res.data.returnData.invalidSkus || [];
              list = skus.concat(invalidSkus);
              this.cartList = list;
              // this.$utils.updateImgOssSuffix(this); //检测是否支持webp格式
              this.$store.commit("upDateShopCount", list.length);
              this.checkGoodStatus();
              resolve(list);
            } else {
              reject(res.data.message);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    async getTotalPrice() {
      let list = await this.getCartList();
      let cartItemlist = [];
      let checkoutList = [];
      this.$emit("getCartCount", list.length);
      list.forEach((v, i) => {
        if (v.status == 0 || v.status == 3) {
          checkoutList.push(v);
          cartItemlist.push(v.cartItemId);
        }
      });
      let url = this.API.checkout.checkoutByCart;
      this.cartItems = cartItemlist.join(",");
      let OpenId=await this.$utils.CheckOpenIdExist(this);
      let params = {
        openId: OpenId || this.$store.state.userId,
        cartItems: cartItemlist.join(","),
        merchantId: this.$store.state.storeId,
        distributorId: "",
        isAutoPromo: false
      };
      this.$http
        .post(url, this.$qs.stringify(params))
        .then(res => {
          if (res.data.result) {
            this.payAmount = res.data.returnData.payAmount;
          } else {
            // this.$Message.error(res.data.message)
          }
        })
        .catch(err => {});
    },
    goToShopCart() {
      this.$emit("makeShopShow", false);
      this.getLoginStatus().then(res => {
        if (res) {
          this.$store.commit("setValue", ["showLoginPop", true]);
          return;
        } else {
          this.goRouter("/shop-cart");
        }
      });
    },

    //GA begin_checkout埋点
    gaBeginCheckout() {
    
      this.$gaAction.begin_checkout(this.cartList, this.payAmount);
    },

    goPay() {
      if (this.payAmount == 0) {
        this.$Message.error("购物袋无有效商品");
        return;
      }
      if ((this.isSoldOut || this.isSellOut) && !this.ISNEXT) {
        this.leavePopShow = true;
        return;
      } else {
        let url = this.$store.state.API.my.getUserInfo;
        this.$http
            .get(url, {
              headers: { tb_token: window.localStorage.getItem("token") }
            })
            .then(res => {
              if (res.data.result) {
          
                let crmMember = res.data.returnData.crmMember;
                if (!crmMember) {
                  this.$store.commit("setValue", ["getShowAdd", true]);
                } else {
                  this.$emit("makeShopShow", false);
                  this.$router.push({
                    path: "/checkout",
                    query: {
                      cartItems: this.cartItems
                    }
                  });
                }
              }})
      }
      this.gaBeginCheckout();
    },
    //GA remove_from_cart埋点
    gaRemoveFromCart(gaData) {
      this.$gaAction.remove_from_cart(gaData);
    },
    async removeCartitem(id, index, goodInfo) {
      this.gaRemoveFromCart(goodInfo);
      let url = this.API.shopcart.deleteCart;
      let OpenId=await this.$utils.CheckOpenIdExist(this);
      let params = {
        cartItemId: id,
        openId: OpenId || this.$store.state.userId
      };
      this.$http
        .post(url, this.$qs.stringify(params))
        .then(res => {
          if (res.data.result) {
            this.cartList.splice(index, 1);
            // this.$store.commit("upDateShopCount", this.cartList.length);
            this.getTotalPrice();
            this.$Message.success("移除成功");
          }
        })
        .catch(err => {});
    },
    confirmPop() {
      this.ISNEXT = true;
      this.goPay();
    },
    cancelPop() {
      this.leavePopShow = false;
    },
    //GA view_item埋点
    gaViewItem(dataList) {
      if (dataList.length != 0) {
        let gaData = [];
        for (let i in dataList) {
          gaData.push(dataList[i]);
        }
        
        this.$gaAction.view_item(gaData, "cart_fw");
      }
    },
    //GA select_content埋点
    gaSelectContent(good, index) {
      this.$set(good, "list_position", index);
      this.$set(good, "list_name", "cart_fw");
      this.$gaAction.select_content(good);
    }
  }
};
</script>
<style lang="less" scoped>
.min-bag-container {
  top: calc(100% - 0.1rem);
  width: 36rem;
  max-width: 36rem;
  position: absolute;
  right: 0;
  min-height: 9rem;
  max-height: calc(95vh - 3.5rem);
  // position: relative;
  z-index: 51;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 0.1rem solid #eaeaea;
  background-color: #fff;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.4s ease-out, visibility 0.4s;
  &.show-cart {
    opacity: 1;
    visibility: visible;
  }
  .no-data {
    .title {
      text-align: left;
      padding: 2rem;
      border-bottom: 0.1rem solid #eaeaea;
    }
  }

  .cart-list {
    max-height: 33rem;
    overflow: auto;
    .cart-item {
      // display: flex;
      // border-top: 0.1rem solid #e5e5e5;
      cursor: pointer;
      position: relative;
      padding: 2rem;
      display: flex;
      border-bottom: 0.1rem solid #eaeaea;

      .cart-img {
        // flex: 1.2;
        min-width: 4.6rem;
        max-width: 5.2rem;
      }
      .cart-info {
        display: flex;
        justify-content: space-between;
        flex: 1;
        margin-left: 2rem;
        color: #8e8f8b;

        .cart-info-detail {
          text-align: left;
          .last-pro {
            // height: 2rem;
            //  line-height: 2rem;
            padding: 0.2rem 1.4rem;
            display: inline;
            border: 0.1rem solid #5c5d5f;
            text-transform: none;
            white-space: nowrap;
            color: #5c5d5f;
            margin-left: 1.4rem;
            display: none;
          }
          // .good-name {
          //   margin-bottom: 2.5rem;
          //   display: flex;
          //   justify-content: center;
          //   align-items: center;
          //   .last-pro {
          //     padding: 0.2rem 0.6rem;
          //     display: inline;
          //     border: 0.1rem solid #eaeaea;
          //     text-transform: none;
          //     white-space: nowrap;
          //     color: #5c5d5f;
          //     margin-left: 1.4rem;
          //   }
          // }
          // .good-size,
          // .good-color {
          //   margin-bottom: 1rem;
          // }

          // .good-num {
          //   margin-bottom: 1.6rem;
          // }
        }
        .remove {
          color: #5c5d5f;
          cursor: pointer;
        }
        .cart-price {
          text-align: right;
        }
      }
      .cart-right {
      }
    }
  }
  .summary {
    .all-price {
      height: 5rem;
      padding: 0 2rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 0.1rem solid #eaeaea;
    }
  }
  .go-cart {
    color: #5c5d5f;
    background-color: #fff;
    font-weight: 500;
    .icon {
      transform: rotate(-180deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/MinShopBag.vue